import { render, staticRenderFns } from "./MoleculeEditionProductAssetsIncludedSubMenu.vue?vue&type=template&id=52f62d2e&"
import script from "./MoleculeEditionProductAssetsIncludedSubMenu.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionProductAssetsIncludedSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports